import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function DailyConsolidate(props){
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rows, setRows] = useState([]);
  const [combinedData, setCombinedData] = useState([]);
  const [returnData, setreturnData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
    const [totalByDate, setTotalByDate] = useState({});
  const [totalReturnByDate, setTotalReturnByDate] = useState({});
  const today = new Date();
  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};
 const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};

  useEffect(() => {
      fetchData();
  }, [startDate, endDate]);

  async function fetchData() {
  setIsLoading(true);
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
  setCombinedData([]);
  const url = `${baseUrl}all-pharm-sale/?start_date=${startDateString}&end_date=${endDateString}&status=1`;
  try {
      const response = await axios.get(url);
      const groupedData = response.data.reduce((acc, cur) => {
        const date = cur.add_date_date;
        if (!acc[date]) {
          acc[date] = {
            total: 0,
            paid: 0,
            returnAmount: 0, // Initialize returnAmount as 0
          };
        }
        acc[date].total += parseFloat(cur.total);
        const paidAmount = parseFloat(cur.paid) || 0; // Convert empty or NaN paid values to 0
          acc[date].paid += paidAmount;
        return acc;
      }, {});
       const groupedRows = Object.entries(groupedData).map(([date, amounts]) => ({
        add_date_date: date,
        total: amounts.total.toFixed(2),
        paid: amounts.paid.toFixed(2),
        returnAmount: 0,
      }));
      setCombinedData(groupedRows);
      setTotalByDate(groupedData);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    };
    const url1 = `${baseUrl}sale-return-report/?start_date=${startDateString}&end_date=${endDateString}&status=1`;
    try {
      const response1 = await axios.get(url1);
      const groupedData = response1.data.reduce((acc, cur) => {
        const date = cur.add_date_date;
        if (!acc[date]) {
          acc[date] = {
            total: 0,
            paid: 0,
            returnAmount: 0,
          };
        }
        const returnAmount = parseFloat(cur.total) || 0;
        acc[date].total += returnAmount;
        acc[date].paid += returnAmount;
        acc[date].returnAmount += returnAmount;
        return acc;
      }, {});

      const groupedRows = Object.entries(groupedData).map(([date, amounts]) => ({
      add_date_date: date,
      total: 0,
      paid: 0,
      returnAmount: amounts.returnAmount,
    }));

      const updatedData = groupedRows.map(row => {
        const returnAmount = groupedData[row.add_date_date]?.returnAmount || row.returnAmount;
      return {
        ...row,
        returnAmount: returnAmount.toFixed(2),
      };
    });

      const returnOnlyDates = Object.keys(groupedData).filter(date => !groupedRows.find(row => row.add_date_date === date));
        returnOnlyDates.forEach(date => {
          const returnAmount = groupedData[date].returnAmount.toFixed(2);
          updatedData.push({
            add_date_date: date,
            total: '0.00',
            paid: '0.00',
            returnAmount: returnAmount,
          });
        });
        updatedData.sort((a, b) => {
          const dateA = new Date(a.add_date_date);
          const dateB = new Date(b.add_date_date);
          return dateA - dateB;
        });
      setreturnData(response1.data);
      setCombinedData(prevCombinedData => [...prevCombinedData, ...updatedData]);
      setTotalReturnByDate(groupedData);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    };
  }

  const columns = [
    { field: 'add_date_date', headerName: 'Date', width: 120 },
    { field: 'total', headerName: 'Amount', width: 150 },
    { field: 'paid', headerName: 'Paid Amount', width: 150 },
    { field: 'returnAmount', headerName: 'Return Amount', width: 150 },
  ];
  const totalRow = (
  <tr>
    <td colSpan="5">Total</td>
    <td>{Object.values(totalByDate).reduce((total, item) => total + item.total, 0).toFixed(2)}</td>
    <td>{Object.values(totalByDate).reduce((total, item) => total + item.paid, 0).toFixed(2)}</td>
    <td colSpan="2"></td>
  </tr>
);

  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> Daily Consolidate Report</h3>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
            <div className="col-sm-9 col-lg-10 controls">
            <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderheaderName={'Please select From date'}
                dateFormat="dd/MM/yyyy"
            />
            </div>
            <div className="col-sm-9 col-lg-10 controls">
            <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                maxDate={today}
                placeholderheaderName={'Please select To date'}
                dateFormat="dd/MM/yyyy"
            />
            </div>
            </div>
        </div>
      </div>
    {!isLoading && combinedData.length > 0 ? (
              <div style={{ height: "100%", width: "100%" }}>
                <DataGrid
                  className="mt-4"
                  sx={{
                    boxShadow: 4,
                    border: 4,
                    borderColor: 'primary.light',
                    '& .MuiDataGrid-cell:hover': {
                      color: 'primary.main',
                    },
                  }}
                  rows={combinedData.map((row, index) => ({
                    ...row,
                    id: index + 1, // Adda unique id property to each row
                  }))}
                  columns={columns}
                  pageSize={10}
                  slots={{
                    toolbar: GridToolbar,
                  }}
                  initialState={{
                    sorting: {
                      sortModel: [{ field: 'add_date_date', sort: 'asc' }],
                    },
                  }}
                  autoHeight
                />
                <table className="mt-4" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tfoot>
                      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px' }}>
                        <div>Total Invoiced Amount: {Object.values(totalByDate).reduce((total, item) => total + item.total, 0).toFixed(2)}</div>
                        <div>Total Paid Amount: {Object.values(totalByDate).reduce((paid, item) => paid + item.paid, 0).toFixed(2)}</div>
                        <div>Total Return Amount: {Object.values(totalReturnByDate).reduce((total, item) => total + item.total, 0).toFixed(2)}</div>
                      </div>
            </tfoot>
          </table>
              </div>
          ) : (
            <></>
          )}
    </section>
  );
}

export default DailyConsolidate;
